import React, { FC, useState } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import fadeIn from '../../animations/fadeIn';
import './_styles.picker.css';
import { motion } from 'framer-motion';

interface PickerProps {
  title: string;
  onChange?: (value: string) => void;
  initialAmount?: number;
  options: string[];
  delay?: number;
  defaultValue?: string;
  readOnly?: boolean;
}
// Picker: for lack of a better word
const Picker: FC<PickerProps> = ({
  title,
  options,
  onChange,
  delay = 0,
  defaultValue,
  readOnly = false
}) => {
  const [selected, setSelected] = useState(
    defaultValue ? options.indexOf(defaultValue) : 0
  );

  const previous = () => {
    const newValue = selected - 1 < 0 ? options.length - 1 : selected - 1;

    if (onChange) {
      onChange(options[newValue]);
    }

    setSelected(newValue);
  };
  const next = () => {
    const newValue = selected + 1 === options.length ? 0 : selected + 1;

    if (onChange) {
      onChange(options[newValue]);
    }

    setSelected(newValue);
  };

  return (
    <motion.div
      className='picker'
      variants={fadeIn(0.5 + delay)}
      initial='hidden'
      animate='enter'
      exit='exit'
    >
      <p>{title}</p>
      <div className='picker-container'>
        {!readOnly && (
          <button onClick={previous} className='picker-button'>
            <FaChevronLeft />
          </button>
        )}
        <div>
          <p>{options[selected]}</p>
        </div>
        {!readOnly && (
          <button onClick={next} className='picker-button'>
            <FaChevronRight />
          </button>
        )}
      </div>
    </motion.div>
  );
};

export default Picker;
